import { Node, mergeAttributes } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import DataChipAdapter from '../DataChip/DataChipAdapter.vue';

import { DATA_CHIP_HTML_TAG } from '../DataChip/data-chip.const';

export default Node.create({
	name: 'DataChipExtensions',
	group: 'inline',
	// content: 'inline*', // this caused a major bug of 'inlining the component as text' after keystroke
	atom: true,
	inline: true,
	selectable: true,
	defining: true, //If a node should be kept for such replace operations (e.g. copy paste)
	// isolating: true, // fence backspace

	addAttributes() {
		return {
			content: { default: 'no_content_found' },
		};
	},
	parseHTML() {
		return [{ tag: DATA_CHIP_HTML_TAG }];
	},

	renderHTML({ HTMLAttributes }) {
		return [DATA_CHIP_HTML_TAG, mergeAttributes(HTMLAttributes)];
	},
	// Used to convert an atom node to plain text
	renderText({ node }) {
		return `@${node.attrs.id}`;
	},

	// addCommands() {
	// 	return {
	// 		insertChip: (attributes) => ({ chain }) => {
	// 			console.log('lalalalal');
	// 			return chain().focus().insertContent('vueComponent', attributes); //.insertText(' ').run();
	// 		},
	// 	};
	// },

	addNodeView() {
		return VueNodeViewRenderer(DataChipAdapter);
	},

	// onCreate() {
	// 	// The editor is ready.
	// },
	// onUpdate(aaa) {
	// 	// The content has changed.
	// 	console.log('onUpdate: ', aaa);
	// },
	// // onSelectionUpdate({ editor }) {
	// // 	// The selection has changed.
	// // },
	// // onTransaction({ transaction }) {
	// // 	// The editor state has changed.
	// // },
	// // onFocus({ event }) {
	// // 	// The editor is focused.
	// // },
	// // onBlur({ event }) {
	// // 	// The editor isn’t focused anymore.
	// // },
	// onDestroy() {
	// 	// The editor is being destroyed.
	// },
	// // addInputRules() {
	// // 	return [new InputRule(/-___- $/, '😑 '), new InputRule(/{{ $/, '<data-chip>'), new InputRule(/}} $/, '</data-chip>')];
	// // },
});
